import type { DeleteWidgetResponse } from "$/lib/types/api/custom-dashboard.types";
import { restApiClient } from "../restApiClient";

export const deleteWidget = async (widgetId: number) => {
  return restApiClient
    .url(`/custom-dashboard/${widgetId}`)
    .delete<DeleteWidgetResponse>();
};
